export default __webpack_public_path__ + "static/media/12.10624ad3.svg";